import styled from 'styled-components';

import { Text } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { mediaQueries } from '@sternum/web/config/mediaQueries';
import { ct } from '@sternum/web/utils/theme';

export const Container = styled.div`
  background: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
  color: ${ct({ Dark: Colors.White, Light: Colors.White })};
  padding: 25px 20px;
  position: relative;

  @media (${mediaQueries.lg}) {
    display: flex;
    align-items: center;
    height: 171px;
    padding: 0 40px;
  }

  @media (${mediaQueries.xl}) {
    height: 193px;
    padding: 0 70px;
  }

  @media (${mediaQueries.xxl}) {
    height: max(30vh, 230px);
    padding: 0 130px;
  }
`;

export const TextContent = styled.div`
  position: relative;
  z-index: 2;

  @media (${mediaQueries.lg}) {
    max-width: 50%;
  }

  @media (${mediaQueries.xxl}) {
    max-width: none;
  }
`;

export const DecorationIconWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`;

export const TitleTop = styled(Text)`
  display: block;
  font-size: 18px;
  font-weight: 600;
  color: ${ct({ Dark: Colors.BrandBlueLight, Light: Colors.BrandBlueLight })};
  margin-bottom: 12px;

  @media (${mediaQueries.xl}) {
    font-size: 21px;
    margin-bottom: 20px;
  }
`;

export const TitleBottom = styled(Text)`
  display: block;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  color: ${ct({ Dark: Colors.BrandBlueLight, Light: Colors.BrandBlueLight })};

  @media (${mediaQueries.lg}) {
    font-size: 32px;
    line-height: 42px;
  }
`;
